import Vue from 'vue';
import ElementUI from 'element-ui';
import Viewer from 'v-viewer';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import axios from './http';
import VueI18n from 'vue-i18n';

import router from './router';

router.afterEach((to, from, next) => {
  window.scrollTo(0,0);
});

Vue.prototype.GLOBAL = {
  lang: 'cn',
};

Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Viewer);
Vue.use(VueI18n);
/* eslint-disable no-new */


const i18n = new VueI18n({
  locale: 'en',
  messages: {
    'zh': require('./assets/json/zh.json'),
    'en': require('./assets/json/en.json')
  }
});

new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js